export default __webpack_public_path__ + "static/media/uv5_en_star_b1.ec53c62d.mp3";